module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"uk":{"logo":"Головна сторінка"},"en":{"logo":"Home page"}}')
  delete Component.options._Ctor
}
